export enum EvaluationTypeEnum {
  LikretScale,
  Percent,
  Both,
}
